import { FC } from "react";
import { Box, Heading } from "@chakra-ui/react";

import { useGetLimitQuery } from "../../../../../api/limit";
import { useSbpTransferStore } from "../../../../../store/sbpTransferStore";
import { SbpTransferPageScheduleEmpty } from "./SbpTransferPageScheduleEmpty";
import { SbpTransferPageScheduleContent } from "./SbpTransferPageScheduleContent";
import { MIN_SBP_TRANSFER_AMOUNT } from "../SbpTransferPageAmountWithTerm/SbpTransferPageAmount";

export const SbpTransferPageSchedule: FC = () => {
  const { data: limit } = useGetLimitQuery();
  const amount = useSbpTransferStore(s => s.amount);
  const term = useSbpTransferStore(s => s.term);

  const showScheduleData
      = !!term
      && Number(amount) >= MIN_SBP_TRANSFER_AMOUNT
      && Number(amount) <= Number(limit?.cashBalance);

  return (
    <Box bg="white" borderRadius="16px" p="20px">
      <Heading mt="0px" mb="13px" fontSize="16px" lineHeight="1">График платежей</Heading>

      {showScheduleData
        ? <SbpTransferPageScheduleContent />
        : <SbpTransferPageScheduleEmpty />}
    </Box>
  );
};
